import { listToMap } from '../common'

import IepProgress from './types/IepProgress'

const PROGRESS_IEP = 'iep'

const ALL_PROGRESS_SPECIFICATIONS = [{ id: PROGRESS_IEP, Component: IepProgress }]

const PROGRESS_SPECIFICATIONS = listToMap(ALL_PROGRESS_SPECIFICATIONS)

export { PROGRESS_IEP, PROGRESS_SPECIFICATIONS }
